// import ContractList from 'page/contract/ContractList';
// import DeviceActiveAlert from 'page/device/DeviceActiveAlert';
// import DeviceActivity from 'page/device/DeviceActivity';
// import DeviceAlertHistory from 'page/device/DeviceAlertHistory';
// import DeviceDetail from 'page/device/DeviceDetail';
// import DeviceList from 'page/device/DeviceList';
// import DeviceStatus from 'page/device/DeviceStatus';
// import DeviceStatus2 from 'page/device/DeviceStatus2';
import Home from 'page/Home';
import AuthLog from 'page/user/AuthLog';
import NotifyHistory from 'page/notify/NotifyHistory';
import UserInfo from 'page/user/UserInfo';
import UserList from 'page/user/UserList';
import UserDetail from 'page/user/UserDetail';
import AppUserList from 'page/appuser/AppUserList';
import AppChannelList from 'page/appchannel/AppChannelList';
import PocUserList from 'page/pocaccount/PocUserList';
import CouponList from 'page/coupon/CouponList';
import PocUserDetail from 'page/pocaccount/PocUserDetail';
import PocUserAddChannels from 'page/pocaccount/PocUserAddChannels';
import PocUserRemoveChannels from 'page/pocaccount/PocUserRemoveChannels';
import PocChannelList from 'page/pocchannel/PocChannelList';
import PocChannelDetail from 'page/pocchannel/PocChannelDetail';
import PocChannelHost from 'page/pocchannel/PocChannelHost';
import PocChannelAddHost from 'page/pocchannel/PocChannelAddHost';
import PocChannelAddMembers from 'page/pocchannel/PocChannelAddMembers';
import PocChannelRemoveMembers from 'page/pocchannel/PocChannelRemoveMembers';
import UserMaintenance from 'page/user/UserMaintenance';
import Policy from 'page/policy/Policy';
import Summary from 'page/summary/Summary';
import SendInvoice from 'page/invoice/SendInvoice';
import Paths from './paths';
import { ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_MONITOR, ACCOUNT_ROLE_NORMAL } from './permission';
import TermsOfUse from 'page/termsofuse/TermsOfUse';
import CallLogs from 'page/calllogs/CallLogs';
import ChannelLogs from 'page/calllogs/ChannelLogs';
import ServiceCodeList from 'page/servicecode/ServiceCodeList';
import ServiceCodeDetail from 'page/servicecode/ServiceCodeDetail';
import PurchaseDetail from 'page/purchase/PurchaseDetail';
import PcAssignAppId from 'page/purchase/PcAssignAppId';
import Links from 'page/links/Links';
import ServerLogs from 'page/serverlogs/ServerLogs';
import ServerLogsDetails from 'page/serverlogs/ServerLogsDetail';
import SuccessNotify from 'page/purchase/PcSuccessNotify';
import PcHistoryUser from 'page/purchase/PcHistoryUser';
import PcHistoryAdmin from 'page/purchase/PcHistoryAdmin';
import PcHistoryDetail from 'page/purchase/PcHistoryDetail';
import PocUserTrial from 'page/pocaccount/PocUserTrial';

const Routes = [
  { path: Paths.root, component: Home },
  // User management
  {
    path: Paths.user.list,
    component: UserList,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },
  {
    path: Paths.user.info,
    component: UserInfo,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },
  {
    path: Paths.user.log,
    component: AuthLog,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },
  {
    path: Paths.user.update,
    component: UserMaintenance,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },
  {
    path: Paths.user.details,
    component: UserDetail,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },

  // App user management
  {
    path: Paths.appuser.list,
    component: AppUserList,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // App channel management
  {
    path: Paths.appchannel.list,
    component: AppChannelList,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // App privacy policy
  {
    path: Paths.policy.privacy,
    component: Policy,
    // permissions: [ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL],
  },
  {
    path: Paths.policy.privacy2,
    component: Policy,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // App terms of use
  {
    path: Paths.termsofuse.termsofuse,
    component: TermsOfUse,
    // permissions: [ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL],
  },
  {
    path: Paths.termsofuse.termsofuse2,
    component: TermsOfUse,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // Poc account
  {
    path: Paths.pocaccount.list,
    component: PocUserList,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },
  {
    path: Paths.pocaccount.detail,
    component: PocUserDetail,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },
  {
    path: Paths.pocaccount.addchannels,
    component: PocUserAddChannels,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },
  {
    path: Paths.pocaccount.removechannels,
    component: PocUserRemoveChannels,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // Poc channel
  {
    path: Paths.pocchannel.list,
    component: PocChannelList,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // Poc channel detail
  {
    path: Paths.pocchannel.detail,
    component: PocChannelDetail,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // Poc channel add members
  {
    path: Paths.pocchannel.addmembers,
    component: PocChannelAddMembers,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // Poc channel remove members
  {
    path: Paths.pocchannel.removemembers,
    component: PocChannelRemoveMembers,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // Poc channel host
  {
    path: Paths.pocchannel.host,
    component: PocChannelHost,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // Poc channel add host
  {
    path: Paths.pocchannel.addhost,
    component: PocChannelAddHost,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },

  // Notify history
  {
    path: Paths.notify.log,
    component: NotifyHistory,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },

  // Summary
  {
    path: Paths.summary.summary,
    component: Summary,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },

  // Invoice
  {
    path: Paths.invoice.invoice,
    component: SendInvoice,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },

  // Coupon
  {
    path: Paths.coupon.coupon,
    component: CouponList,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },
  //Call Logs
  {
    path: Paths.calllogs.calllogs,
    component: CallLogs,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },
  //Channel log
  {
    path: Paths.channellogs.channellogs,
    component: ChannelLogs,
    permissions: [ ACCOUNT_ROLE_ADMIN ],
  },
  //Service Code
  {
    path: Paths.servicecode.servicecode,
    component: ServiceCodeList,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ],
  },
  {
    path: Paths.servicecode.assign,
    component: ServiceCodeDetail,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ]
  },
  {
    path: Paths.purchase.purchasedetails,
    component: PurchaseDetail,
    permissions: [ ACCOUNT_ROLE_NORMAL ]
  },
  {
    path: Paths.purchase.purchaseAssignId,
    component: PcAssignAppId,
    permissions: [ ACCOUNT_ROLE_NORMAL ]
  },
  {
    path: Paths.links.links,
    component: Links,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ]
  },
  {
    path: Paths.serverlogs.serverlogs,
    component: ServerLogsDetails,
    permissions: [ ACCOUNT_ROLE_ADMIN ]
  },
  {
    path: Paths.serverlogs.getfiles,
    component: ServerLogs,
    permissions: [ ACCOUNT_ROLE_ADMIN ]
  },
  {
    path: Paths.notifyfincode.success,
    component: SuccessNotify,
    permissions: [ ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL ]
  },
  {
    path: Paths.fincode.user,
    component: PcHistoryUser,
    permissions: [ ACCOUNT_ROLE_NORMAL ]
  },
  {
    path: Paths.fincode.admin,
    component: PcHistoryAdmin,
    permissions: [ ACCOUNT_ROLE_ADMIN ]
  },
  {
    path: Paths.fincode.orderdatail,
    component: PcHistoryDetail,
    permissions: [ ACCOUNT_ROLE_NORMAL ]
  },
  {
    path: Paths.pocaccount.trial,
    component: PocUserTrial,
    permissions: [ ACCOUNT_ROLE_NORMAL, ACCOUNT_ROLE_ADMIN ]
  }





  // {
  //   path: Paths.contract.list,
  //   component: ContractList,
  //   permissions: [ACCOUNT_ROLE_ADMIN],
  // },
  // {
  //   path: Paths.device.list,
  //   component: DeviceList,
  //   permissions: [ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL],
  // },
  // { path: Paths.device.detail, component: DeviceDetail },
  // // {
  // //   path: Paths.device.status,
  // //   component: DeviceStatus,
  // //   permissions: [ACCOUNT_ROLE_NORMAL, ACCOUNT_ROLE_CHILD],
  // // },
  // {
  //   path: Paths.device.status,
  //   component: DeviceStatus2,
  // },
  // {
  //   path: Paths.device.statusSF07,
  //   component: DeviceStatus2,
  // },
  // {
  //   path: Paths.device.statusWBGT,
  //   component: DeviceStatus2,
  // },
  // {
  //   path: Paths.device.statusGPS,
  //   component: DeviceStatus2,
  // },
  // {
  //   path: Paths.device.statusSF03WT,
  //   component: DeviceStatus2,
  // },
  // {
  //   path: Paths.device.statusSF03WT2,
  //   component: DeviceStatus2,
  // },
  // {
  //   path: Paths.device.statusXE1151,
  //   component: DeviceStatus2,
  // },
  // {
  //   path: Paths.device.activity,
  //   component: DeviceActivity,
  //   permissions: [ACCOUNT_ROLE_ADMIN],
  // },
  // {
  //   path: Paths.device.activeAlert,
  //   component: DeviceActiveAlert,
  //   permissions: [ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL],
  // },
  // {
  //   path: Paths.device.alertHistory,
  //   component: DeviceAlertHistory,
  //   permissions: [ACCOUNT_ROLE_ADMIN, ACCOUNT_ROLE_NORMAL],
  // },
];

export const RouteMap = Routes.reduce((curResult, curElm) => {
  curResult[ curElm.path ] = curElm;
  return curResult;
}, {});

export default Routes;
